import requset from "utils/request";
import {
  BENDI
} from "apiurl/index.js";
const domain = 'https://web-api.zhangwenjiandu.com'
export function orderStatus(params) { //查询订单状态
  return requset({
    url: domain + "/orders/status",
    method: "post",
    params,
    headers: {
      'need': 1
    }
  });
}
export function ordersPay(params) { //下单
  return requset({
    url: domain + "/orders",
    method: "post",
    params,
    headers: {
      'need': 1
    }
  });
}
export function orderApi(params) { //订单列表
  return requset({
    url: domain + "/orders/prices",
    method: "get",
    params,
    headers: {
      'need': 1
    }
  });
}
export function ordersList(params) { //消费记录
  return requset({
    url: domain + "/orders",
    method: "get",
    params,
    headers: {
      'need': 1
    }
  });
}
export function getcodeApi(params) { //获取验证码
  return requset({
    url: domain + "/auth/sms/code",
    method: "get",
    params,
    headers: {
      'need': 1
    }
  });
}
export function registerApi(params) { //注销账号
  return requset({
    url: domain + "/me/un-register",
    method: "post",
    params,
    headers: {
      'need': 1
    }
  });
}
export function loginApi(params) { //用户登录
  return requset({
    url: domain + "/auth/login",
    method: "POST",
    params,
    headers: {
      'need': 1
    }
  });
}
export function useInfoApi(params) { //用户信息
  return requset({
    url: domain + "/session",
    method: "get",
    params,
    headers: {
      'need': 1
    }
  });
}
/* 登录 */
export function login(data) {
  return requset({
    url: BENDI + "/auth/login",
    method: "POST",
    data
  });
}
/* 正在登陆qq */
export function loginstatic(params) {
  return requset({
    url: BENDI + "/third/auth/login/qq",
    method: "POST",
    params
  });
}
/* 正在登陆qq */
export function weixinstatic(params) {
  return requset({
    url: BENDI + "/third/auth/login/wx",
    method: "POST",
    params
  });
}
/* 登出 */
export function logout() {
  return requset({
    url: BENDI + "/auth/logout",
    method: "POST"
  });
}
/* 手机号密码登录 */
export function phonelogin(params) {
  return requset({
    url: BENDI + "/auth/code/login",
    method: "POST",
    params
  });
}
/* 获取手机验证码 */
export function getCode(params) {
  return requset({
    url: `${BENDI}/auth/img/mobile/captcha`,
    method: "get",
    params
  });
}
/*  通过手机号注册 */
export function registerMobile(params) {
  return requset({
    url: `${BENDI}/auth/register`,
    method: "post",
    params
  });
}
/* 绑定手机号 */
export function bindMobile(params) {
  return requset({
    url: `${BENDI}/third/auth/mobile/bind`,
    method: "post",
    params
  });
}
/* qq登录 */
export function qqlogin(params) {
  return requset({
    url: `${BENDI}/third/auth/login`,
    method: "post",
    params
  });
}

/* 忘记密码 */
export function forget(params) {
  return requset({
    url: `${BENDI}/account/pwd/reset`,
    method: "post",
    params
  });
}

/* 用户设置 */
// 获取用户信息
export function getuserInfo() {
  return requset({
    url: `${BENDI}/account/info`,
    method: "get"
  });
}
// 修改用户昵称
export function changeUsername(params) {
  return requset({
    url: `${BENDI}/account/username/modify`,
    method: "post",
    params
  });
}
// 设置密码
export function setPassword(params) {
  return requset({
    url: `${BENDI}/account/pwd/set`,
    method: "post",
    params
  });
}
//  修改密码
export function changePassword(params) {
  return requset({
    url: `${BENDI}/account/pwd/modify`,
    method: "post",
    params
  });
}